<div class="autocomplete-serverside" >
  <form class="search-form mobile-view-sort" [formGroup]="searchForm">
    @if (searchoptionalParams.isSearchDropRequired) {
      <div class="search-dropdown">
        <mat-form-field class='basic-select-dropdown' appearance="outline">
          <select id="searchSource" matNativeControl (change)="dropdownChanged($event.target.value)" disableOptionCentering= 'true' >
            @for (dropdown of dataCollection.searchSources; track dropdown) {
              <option id="{{dropdown.SourceName}}" [value]="dropdown.SourceName" [selected] = "dataCollection.defaultItem == dropdown.SourceName" >
                {{dropdown.newSourceName}}
              </option>
            }
          </select>
        </mat-form-field>
      </div>
    }
    <div [ngClass]="componentNameRef === 'barcode' ? 'select-input-barcodeMapping' : 'select-input' ">
      <mat-form-field class="searchInput show-filter-div h-100 basic-input-field" appearance="outline" [ngClass]="{'no-pad':!selectedValue}">
        <input type={{searchType}} id="autoCompleteSearch" placeholder="{{searchoptionalParams.placeholder}}" matInput #inputValue
          (input)="filterData($event.target.value)" (focus)="clearInput($event)" (paste)="pasted($event)" (keydown)="_commonService.issearchtriggered ? $event.preventDefault() : ''"
          formControlName="searchText" autocomplete="off"> <!-- (focusout)='callFO()' (focusin)='callFI()' -->
          @if (searchoptionalParams.barcodeRequired && selectedValue && _commonService.deviceHasCamera ) {
            <i class="icon-bar-code iconFilter" (click)="getBarcode(componentNameRef,functionName)"></i>
          }
          @if (searchoptionalParams.close && closeIcon) {
            <i class="icon-requisition-denied" (click)="clearData()"></i>
          }
        </mat-form-field>
      </div>
    </form>
  </div>

